module.exports = __webpack_public_path__ + "static/img/product02-3.d2f84359.png";